import { CheckoutState } from '../../state';
import {
    areAsyncExpressCheckoutEligibleCommonRulesMet,
    isApplePayAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { hasApplePayAsyncErrors } from './pureSelectors';

export const areAsyncExpressApplePayEligibleRulesMet = (state: CheckoutState) =>
    areAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isApplePayAvailableAsExpressPaymentMethod(state) &&
    !hasApplePayAsyncErrors(state);
